module.exports = __webpack_public_path__ + "media/assets/icons/price-tag-07cd3ed534f773b3aaec2ccd3e9d9737.svg";